/**
 * Create Mobile Nav
 *
 * The mobile nav is a clone of the desktop nav with the various "dropdown"
 * classes stripped out, set into a "drawer" wrapper which is dynamically
 * injected as the first child of <body>.
 *
 * The "drawer" contains a nested drawer where second level menus can be cloned
 * in on demand.
 *
 * This design allows us to avoid generating two sets of markup on render.
 */
createMobileNav();
function createMobileNav() {
  const mainNav = document.querySelector("#menu-main-menu"),
    mobileNavLauncher = document.querySelector(".mobile-nav-launcher");

  // escape hatch
  if (!mainNav || !mobileNavLauncher) return;

  // create wrapper
  const wrapper = document.createElement("div");
  wrapper.classList.add("mobile-nav-drawer");
  wrapper.innerHTML = `<div class="mobile-nav-nested-drawer"></div>`;

  // clone main nav into wrapper
  const menuClone = mainNav.cloneNode(true);
  menuClone.removeAttribute("id");
  wrapper.appendChild(menuClone);

  // remove the "priority nav"
  wrapper.querySelector(".event-menu-overflow").remove();

  // strip dropdowns
  const unwantedClasses = [
    "dropdown",
    "dropdown__trigger",
    "dropdown__items",
    "dropdown__item",
  ];
  wrapper
    .querySelectorAll('[class*="dropdown"]')
    .forEach((el) => el.classList.remove(...unwantedClasses));

  // add classes to nested level links
  wrapper
    .querySelectorAll(".event-menu ul")
    .forEach((subMenu) =>
      subMenu.previousElementSibling.classList.add("trigger-nested")
    );

  // set up the main toggle listener
  mobileNavLauncher.addEventListener("click", (e) =>
    toggleMobileNav(wrapper, e.target.closest("a"))
  );

  // set up the nested toggle listeners
  wrapper.querySelectorAll(".trigger-nested").forEach((el) =>
    el.addEventListener("click", (e) => {
      e.preventDefault();
      toggleNestedMenu(el.nextElementSibling);
    })
  );

  // ensure that clicking anchor links, clip links, etc will close the menu
  wrapper
    .querySelectorAll(".event-menu-item a:not(.trigger-nested)")
    .forEach((el) => {
      el.addEventListener("click", () =>
        toggleMobileNav(wrapper, mobileNavLauncher)
      );
    });

  // insert mobile nav into DOM as the first child of body
  document.body.prepend(wrapper);
}

/**
 * Toggle mobile nav
 *
 * Toggles class changes on our "drawer" and "trigger".
 * The rest is css.
 *
 * @param {HTMLElement} drawer -- The mobile nav wrapper
 * @param {HTMLElement} launcher -- The mobile nav launcher button
 *
 * @see stylesheet _mobile-nav.scss
 */
function toggleMobileNav(drawer, launcher) {
  drawer.classList.toggle("mobile-nav-drawer--open");
  launcher.classList.toggle("mobile-nav-launcher--open");

  drawer
    .querySelector(".mobile-nav-nested-drawer")
    .classList.remove("mobile-nav-nested-drawer--open");
}

/**
 * Toggle nested menu
 *
 * Clones the desired menu into the "nested drawer",
 * and toggles its open/close state
 *
 * @param {HTMLElement} menu
 */
function toggleNestedMenu(menu) {
  const drawer = document.querySelector(".mobile-nav-nested-drawer"),
    backLink = menu.previousElementSibling.cloneNode(true),
    menuClone = menu.cloneNode(true);

  menuClone.classList.add("event-menu");

  backLink.removeAttribute("href");
  backLink.addEventListener("click", () =>
    drawer.classList.toggle("mobile-nav-nested-drawer--open")
  );

  drawer.innerHTML = "";
  drawer.appendChild(backLink);
  drawer.appendChild(menuClone);
  drawer.classList.toggle("mobile-nav-nested-drawer--open");
}
